<template>
  <div> 
    <b-container fluid>
      <nav-bar-component v-on:validated-user="companyId = $event; fetchSettings();"></nav-bar-component>
      <setup-menu-nav-component></setup-menu-nav-component>
    </b-container>
    
    <b-container fluid class="settings-container">
      <b-row>
        <b-col></b-col>
        <b-col cols="4">
          
          <b-card title="Settings" sub-title="Slack Integration Settings">
            <b-alert class="text-left"
                    :show="showError"
                    variant="danger"
                  >{{errorMessage}}</b-alert>
            <b-alert class="text-left"
                    :show="showSuccess"
                    variant="success"
                  >{{successMessage}}</b-alert>
            <b-form-checkbox v-model="slackEnabled" @change="saveSlackToggle($event)" switch class="switchbox">
                {{slackEnabled ? 'Enabled' : 'Disabled'}}
            </b-form-checkbox>
            <b-form-checkbox v-model="usingOwnSlackApp" @change="saveOwnSlackToggle($event)" switch class="switchbox" :disabled="!slackEnabled">
                {{usingOwnSlackApp ? 'Sending messages from your own Slack app.' : 'Slack messages sent from Ravenhub. Turn on this setting to send from your own Slack app.'}}
            </b-form-checkbox>
            <div v-if="usingOwnSlackApp">
            <b-form-group
              id="clienIdLabel"
              description="Client ID for your Slack App"
              label-for="clientIdInput"
            >
              <b-input-group prepend="Slack Client ID" class="mt-3">
                <b-form-input id="clientIdInput" v-model="slackClientId" type="text"></b-form-input>
              </b-input-group>
            </b-form-group>

            <b-form-group
              id="clienSecretLabel"
              description="Client Secret for your Slack App"
              label-for="clientSecretInput"
            >
              
              <b-input-group prepend="Slack Client Secret" class="mt-3">
                <b-form-input id="clientSecretInput" v-model="slackClientSecret" :type="secretInputType"></b-form-input>
                <b-input-group-append>
                  <b-button variant="info" @click="switchVisibility"><b-icon :icon="eyeIcon" variant="primary"></b-icon></b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>

            <b-alert class="text-left"
                    variant="info"
                    show
                  >Set your Slack app's OAuth redirect URL to: https://app.ravenhub.io/slack-auth</b-alert>
            </div>
            <template v-slot:footer>              
              <b-button variant="primary" @click="saveSettings">Save Settings</b-button>
            </template>
          </b-card>
        </b-col>
        <b-col></b-col>
      </b-row>
      


      
    </b-container>
  </div>
</template>

<script>
import NavBarComponent from '@/components/NavBarComponent.vue'
import SetupMenuNavComponent from '@/components/SetupMenuNavComponent.vue'

var Parse = require('parse');
Parse.initialize(process.env.VUE_APP_PARSE_APP_ID, process.env.VUE_APP_PARSE_JS_KEY);
Parse.serverURL = process.env.VUE_APP_PARSE_SERVER_URL;

export default {
  name: 'Settings',
  components : {
    NavBarComponent,
    SetupMenuNavComponent,
  },
  data: function () {
    return {
      companyId: '',
      companyObj: {},
      slackClientId: '',
      slackClientSecret: '',
      secretInputType: 'password',
      eyeIcon: 'eye',
      successMessage: '',
      errorMessage: '',
      showSuccess: false,
      showError: false,
      slackEnabled: false,
      usingOwnSlackApp: false
    }
  },

  mounted: function () {
    
  },
  
  created() {
    
  },
  
  methods: {
    fetchSettings() {
      
      console.log('fetch user - this.companyId = ', this.companyId);
      const Company = Parse.Object.extend("Company");
      const query = new Parse.Query(Company);
      query.equalTo("objectId", this.companyId );
      query.first().then((result) => {
        this.slackClientId = result.get('SlackClientId');
        this.slackClientSecret = result.get('SlackClientSecret');
        this.slackEnabled = result.get('SlackEnabled');
        this.usingOwnSlackApp = result.get('UsingOwnSlackApp');
        this.companyObj = result;
      });
       
    },
    saveSettings() {
      this.showSuccess = false;
      this.showError = false;

      var companyToSave = new Parse.Object("Company", {
          "objectId": this.companyId,
          "SlackClientId": this.slackClientId,
          "SlackClientSecret": this.slackClientSecret
        });
      companyToSave.save()
        .then((result) => {
          console.log(result);
          this.successMessage = 'Settings saved!';
          this.showSuccess = true;
        })
        .catch((e) => {
          this.errorMessage = 'Error saving: ' + e.message;
          this.showError = true;
        })
    },

    saveSlackToggle(event) {
      console.log('switch value = ' + event);
      if (!event) {
        this.usingOwnSlackApp = false;
      }      
      var companyToSave = new Parse.Object("Company", {
          "objectId": this.companyId,
          "SlackEnabled": event,
          "UsingOwnSlackApp": this.usingOwnSlackApp
        });
      companyToSave.save()
        .then((result) => {
          console.log(result);
          this.successMessage = 'Settings saved!';
          this.showSuccess = true;
        })
        .catch((e) => {
          this.errorMessage = 'Error saving: ' + e.message;
          this.showError = true;
        })
    },

    saveOwnSlackToggle(event) {
      console.log('switch value = ' + event);      
      var companyToSave = new Parse.Object("Company", {
          "objectId": this.companyId,
          "UsingOwnSlackApp": event
        });
      companyToSave.save()
        .then((result) => {
          console.log(result);
          this.successMessage = 'Settings saved!';
          this.showSuccess = true;
        })
        .catch((e) => {
          this.errorMessage = 'Error saving: ' + e.message;
          this.showError = true;
        })
    },

    switchVisibility() {
      this.secretInputType = this.secretInputType === 'password' ? 'text' : 'password';
      this.eyeIcon = this.eyeIcon === 'eye' ? 'eye-slash' : 'eye';
    }

    
  }
}
</script>

<style scoped>
.switchbox >>> .custom-control-label {
  cursor: pointer;
}
.settings-container {
  margin-top:20px;
}
</style>
